// WCAG AA-compliant color constants (origin: ADO #32625).
//
// Single source of truth for accessible colors used in React inline styles,
// where sass variables (see src/sass/abstracts/variables.scss) cannot reach.
// Keep these values in sync with the $*-accessible / $*-dark sass variables.
//
// The decorative brand colors (#5F9EC5 blue, #CC5967 red, #E48148 orange) fail
// WCAG 1.4.3 (4.5:1) when used as text on light surfaces; these darker variants
// pass. Use the *Dark variants only for text painted on dark backgrounds.

/** Brand blue as text on light surfaces — >=4.78:1 (was #5F9EC5 @ 2.77:1). */
export const linkColorAccessible = "#3A6E91";

/** Brand blue as text on dark backgrounds — >=4.78:1. */
export const linkColorDark = "#7FB4D4";

/** Reject/error red as text on light surfaces — >=4.88:1 (was #CC5967 @ 4.04:1). */
export const linkRejectAccessible = "#B83A48";

/** Reject/error red as text on dark backgrounds — >=5.09:1. */
export const linkRejectDark = "#E68A95";

/** Urgent orange as text on light surfaces — >=4.80:1 (was #E48148 @ 2.79:1). */
export const urgentColorAccessible = "#A85A1C";

/** Muted grey as text on light surfaces — >=4.77:1 (was #919194 @ 3.14:1). */
export const greyTextAccessible = "#6D6F72";

// VERIFIED badge & Advanced Search label. Keep in sync with the matching sass
// vars in variables.scss — the drift guard in colorTokens.contrast.test.ts fails
// if they diverge.

/** VERIFIED badge green, light theme — AB#34581 re-fix: #2E7D34 computed 5.12:1 on an
 *  assumed white card but QA measured 2.41:1 against the badge's real composited
 *  background (Microsoft.VSTS.CMMI.Analysis, Agent RCA 2026-07-20). #164A1A gives
 *  10.35:1 on the declared white .request-wrapper background and clears AA with margin
 *  even against a conservative surface derived from that real measurement. */
export const verifiedBadgeGreen = "#164A1A";

/** VERIFIED badge green for dark theme, where the summary card is #2c3439 —
 *  5.36:1 (#2E7D34 fails there @ 2.47:1). */
export const verifiedBadgeGreenDark = "#66BB6A";

/** Advanced Search label text on the dark header base — 7.72:1 light (#33576C) /
 *  12.7:1 dark (#2c3439). */
export const advancedSearchLabelText = "#FFFFFF";
